'use client';

import type { CuratorEventItemDTO } from '@musinsa/services-curator';
import { type FC, useMemo } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { CuratorEventCard } from './CuratorEventCard';
import { chunkEventsWithIndex } from './chunkEventsWithIndex';

interface EventListSectionProps {
  events: CuratorEventItemDTO[];
}

export const EventListSection: FC<EventListSectionProps> = ({ events }) => {
  const chunked = useMemo(() => chunkEventsWithIndex(events, 2), [events]);

  if (chunked.length === 0) {
    return null;
  }

  return (
    <Virtuoso
      data={chunked}
      useWindowScroll
      itemContent={(index, row) => (
        <div className="grid grid-cols-2" key={row.map((e) => e.link).join('|') || String(index)}>
          {row.map((event) => (
            <CuratorEventCard key={event.link} event={event} eventsIndex={event._index + 1} />
          ))}
        </div>
      )}
    />
  );
};
